import { DomEvent } from "./DomEvent";
import { Event, EventListener } from "./Event";
import { Table } from "../components/table/Table";
import { TableRow } from "../components/table/TableRow";
import { TableRowMode } from "../components/table/TableRowMode";

export interface TableRowModeChangeListener extends EventListener<TableRowModeChangeEvent> {
}

export class TableRowModeChangeEvent extends Event<TableRow> {
    private table: Table = null;
    private _oldMode: TableRowMode;
    private _newMode: TableRowMode;

    constructor(component: TableRow, table: Table, oldMode: TableRowMode, newMode: TableRowMode, domEvent?: DomEvent) {
        super(component, domEvent);
        this.table = table;
        this._oldMode = oldMode;
        this._newMode = newMode;
    }

    public getTableRow(): TableRow {
        return this.target as TableRow;
    }

    public getTable(): Table {
        return this.table;
    }

    public get oldMode() {
        return this._oldMode;
    }

    public get newMode() {
        return this._newMode;
    }
}
